import * as React from 'react';
import {useCallback, useEffect, useState} from 'react';
import {DiseaseGoldIcon} from '@/interfaces/specialDisease';
import useJumpUrl from '@/hooks/useJumpUrl';
import {VALUE_TYPE} from '@/dicts/consts';
import styles from './index.less';


interface Props {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    goldIcons: DiseaseGoldIcon;
}


const DiseaseGoldIcons = ({goldIcons, page, channelBusinessLine}: Props) => {

    const {navigateToUrl} = useJumpUrl();

    const handleGoldIconClick = useCallback(
        (linkUrl?: string, swanUrl?: string, k?) => {
            const urlParams = {
                linkUrl,
                swanUrl,
            };
            const logParams = {
                page: page,
                value: 'jump_tupian_jingangwei',
                channelId: goldIcons?.channelId,
                pageType: channelBusinessLine,
                moduleId: goldIcons?.moduleId,
                moduleName: goldIcons?.moduleName,
                customize: {
                    // eslint-disable-next-line camelcase
                    value_type: VALUE_TYPE.ITEM,
                    // eslint-disable-next-line camelcase
                    value_id: k.itemId,
                    // eslint-disable-next-line camelcase
                    value_title: k.title,
                },
            };
            navigateToUrl(urlParams, logParams);
        },
        [channelBusinessLine, goldIcons.channelId, goldIcons.moduleId, goldIcons.moduleName, page, navigateToUrl]
    );


    const [maxColumn, setMaxColumn] = useState<number>(4);


    useEffect(
        () => {
            // eslint-disable-next-line no-unused-expressions
            (goldIcons.moduleMaxColumns || 0) > 0
                ? setMaxColumn(goldIcons.moduleMaxColumns || 4)
                : '';
        },
        [goldIcons.moduleMaxColumns]
    );


    return (
        <div
            id={goldIcons.moduleId?.toString()}
            className={styles.diseaseGoldIconContainer}
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_tupian_jingangwei',
                'pageSourceId': goldIcons.channelId,
                'pageType': channelBusinessLine,
                'valueId': goldIcons.moduleId,
                'valueTitle': goldIcons.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >
            {
                goldIcons?.golds?.map(
                    (k, index) => (
                        <div
                            key={k.itemId}
                            onClick={() => handleGoldIconClick(k.fieldValue?.link, k.fieldValue?.swanUrl, k)}
                            hidden={index >= maxColumn * 3}
                            style={{
                                width: `-webkit-calc((100%)/${maxColumn})`,
                            }}
                            data-show={JSON.stringify({
                                'page': page,
                                'value': 'jump_tupian_jingangwei',
                                'pageSourceId': k.channelId,
                                'pageType': channelBusinessLine,
                                'valueId': k.itemId,
                                'valueTitle': k.title,
                                'valueType': VALUE_TYPE.ITEM,
                            })}
                        >
                            <img
                                onClick={() => {}}
                                src={k?.fieldValue?.img}
                                className={styles.diseaseGoldIcon}
                            />
                            <div
                                className={styles.diseaseGoldIconTitle}
                            >
                                {k.fieldValue?.title}
                            </div>
                        </div>
                    ))
            }

        </div>

    );
};

export default DiseaseGoldIcons;
